import { foodI18n } from '@/i18n/en/food.i18n';
import { foodGroupI18n } from '@/i18n/en/food-group.i18n';
import { nutrientI18n } from '@/i18n/en/nutrient.i18n';

type ItemType = 'food' | 'food-group' | 'nutrient';

export const itemTypeI18n: { [key in ItemType]: { en: string } } = {
  food: {
    en: 'Food',
  },
  'food-group': {
    en: 'Group',
  },
  nutrient: {
    en: 'Nutrient',
  },
};

export const itemTypeEmoji: { [key in ItemType]: string } = {
  food: '🥦',
  nutrient: '🧬',
  'food-group': '👨‍👩‍👦‍👦',
};

export type SearchOption = {
  id: string;
  name: string;
  type: ItemType;
};

const foods: SearchOption[] = Object.entries(foodI18n).map(([id, name]) => ({
  id,
  name,
  type: 'food',
}));
const foodGroups: SearchOption[] = Object.entries(foodGroupI18n).map(
  ([id, name]) => ({
    id,
    name,
    type: 'food-group',
  })
);
const nutrients: SearchOption[] = Object.entries(nutrientI18n).map(
  ([id, name]) => ({
    id,
    name,
    type: 'nutrient',
  })
);
export const searchOptions: SearchOption[] = [
  ...foods,
  ...foodGroups,
  ...nutrients,
];
